module.exports = __webpack_public_path__ + "uy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/uy.svg
// module id = 870
// module chunks = 0